var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Typography from '../Typography';
const headerHeight = 1.5;
const PointsSC = styled.div `
  outline: 0;

  font-family: ${(p) => p.theme.FontFamilyBase};
  font-size: ${(p) => p.theme.SizeFontPointsBase};
  line-height: ${(p) => p.theme.SizeLineHeightPointsBase};
  font-weight: ${(p) => p.theme.ContentFontWeightPointsBase};
  color: ${(p) => p.theme.ColorFontTypographyBase};

  padding: 0;
  min-width: 250px;
  max-width: 100%;

  ._ndsPoints__icon {
    height: ${headerHeight}rem;
    width: ${headerHeight}rem;
    display: inline-flex;
    align-items: center;
    margin-right: 0.25rem;
    float: left;
  }

  ._ndsPoints__label {
    width: calc(100% - 5rem);
    display: inline-block;
    padding-top: 0.125rem;
    overflow-wrap: break-word;
    white-space: normal;
    float: left;

    * {
      display: inline;
    }
  }

  ._ndsPoints__label--full-width {
    width: calc(100% - 2rem);
  }
  ._ndsPoints__label--disabled * {
    color: ${(p) => p.theme.ColorFontPointsDisabled};
    cursor: not-allowed;
  }

  ._ndsPoints__label__icon {
    height: ${headerHeight}rem;
    display: inline-flex;
    align-items: center;
    float: right;
  }
  ._ndsPoints__icon--disabled {
    opacity: 0.6;
  }

  ._ndsPoints__breakdowns {
    clear: both;
    padding: 0.375rem 0 0 1.75rem;
  }

  ._ndsPoints__breakdowns__item {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    color: ${(p) => p.theme.ColorFontPointsBreakdownBase};
  }

  ._ndsPoints__breakdowns__item__title {
    flex-grow: 1;
    flex-shrink: 0;
  }

  ._ndsPoints__breakdowns__item__value {
    flex-grow: 0;
    flex-shrink: 0;
    margin-left: auto;
  }
`;
const Points = (props) => {
    const { pointsIcon, label, labelIcon, breakdowns, disabled, className: classNameProp, forwardedRef } = props, others = __rest(props, ["pointsIcon", "label", "labelIcon", "breakdowns", "disabled", "className", "forwardedRef"]);
    const classes = clsx('_ndsPoints', classNameProp);
    const classesForPointsIcon = clsx('_ndsPoints__icon', {
        '_ndsPoints__icon--disabled': disabled
    });
    const classesForLabel = clsx('_ndsPoints__label', {
        '_ndsPoints__label--full-width': !labelIcon,
        '_ndsPoints__label--disabled': disabled
    });
    const showBreakdowns = breakdowns && breakdowns.length > 0;
    const labelToRender = typeof label === 'string' ? React.createElement(Typography, { variant: "body3" }, label) : label;
    return (React.createElement(PointsSC, Object.assign({ ref: forwardedRef, className: classes }, others),
        React.createElement("div", { className: "_ndsPoints_header" },
            React.createElement("div", { className: classesForPointsIcon }, pointsIcon),
            React.createElement("div", { className: classesForLabel }, labelToRender),
            labelIcon && React.createElement("div", { className: "_ndsPoints__label__icon" }, labelIcon)),
        showBreakdowns && (React.createElement("div", { className: "_ndsPoints__breakdowns" }, breakdowns.map((breakdown) => {
            const { title, value } = breakdown;
            return (React.createElement("div", { className: "_ndsPoints__breakdowns__item", key: `${title}-${value}` },
                React.createElement("div", { className: "_ndsPoints__breakdowns__item__title" }, title),
                React.createElement("div", { className: "_ndsPoints__breakdowns__item__value" }, value)));
        })))));
};
Points.propTypes = {
    pointsIcon: PropTypes.element.isRequired,
    label: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]).isRequired,
    labelIcon: PropTypes.element,
    breakdowns: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    forwardedRef: PropTypes.any
};
Points.defaultProps = {
    labelIcon: null,
    breakdowns: [],
    className: undefined,
    disabled: false,
    forwardedRef: null
};
export { Points as PointsRootComp };
export default withForwardedRef(Points);
//# sourceMappingURL=Points.js.map